import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveJobAsset = async (asset, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      let Payload = {
        jobAssetID: asset.jobAssetID,
        jobID: asset.jobID,
        assetID: asset.assetID,
        assetTypeID: asset.assetTypeID,
        budgetedQuantity: asset.budgetedQuantity,
        budgetedCostPerUnit: asset.budgetedCostPerUnit,
        budgetedDuration: asset.budgetedDuration,
        budgetedPricePerUnit: asset.budgetedPricePerUnit,
        budgetedMarkup: asset.budgetedMarkup,
        actualQuantity: asset.actualQuantity,
        actualCostPerUnit: asset.actualCostPerUnit,
        actualDuration: asset.actualDuration,
        actualPricePerUnit: asset.actualPricePerUnit,
        actualMarkup: asset.actualMarkup,
        billToCustomer: asset.billToCustomer,
        billingUnit: asset.billingUnit,
        rentalStatus: asset.rentalStatus,
        providedBy: asset.providedBy,
        sortOrder: asset.sortOrder,
        notes: asset.notes
      };
      const response = await fetch(`${dev_baseUrl}/JobAsset/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else{
        return data;
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
